import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { ResolutionStore } from '../../stores';
import { Resolution } from '../../types/resolution';
import { buildCreditContent } from './resolutionContent';
import { ResolutionSummary } from './resolutionSummary';

export type CreditResolutionInfoProps = {
  resolution: Resolution;
  resolutionStore: ResolutionStore;
  showComment?: boolean;
};

export const CreditResolutionInfo = observer(({ resolution, resolutionStore, showComment }: CreditResolutionInfoProps) => {
  const content = useMemo(() => buildCreditContent(resolution), [resolution?.itemName, resolution?.itemDescription, resolution?.itemData]);

  return <ResolutionSummary resolution={resolution} resolutionStore={resolutionStore} content={content} showComment={showComment} />;
});
